import PropTypes from 'prop-types';

const SVG = ({
  style = {
    fill: '#000000',
  },
}) => (
  <svg style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.92 46.36">
    <path
      d="M40.56 8.53A11.24 11.24 0 0028.67.02 13.79 13.79 0 0018.6 5.1 12.64 12.64 0 0016.71 8a12.73 12.73 0 00-8.18-.76A11.24 11.24 0 00.02 19.18a13.79 13.79 0 005.08 10 13.19 13.19 0 007.14 3.1 13.41 13.41 0 006.22 12.46 11.24 11.24 0 0014.42-2.39 13.79 13.79 0 003.53-10.72 13.44 13.44 0 00-3.33-7.83c.58-.32 1.15-.68 1.71-1.05a13.51 13.51 0 005.77-14.22zM2.12 20.64C.88 14.02 5.04 9.77 9.85 9.06a11 11 0 016.16.75 10.69 10.69 0 011.83 1 13.39 13.39 0 013 3q.6.81 1.11 1.65a27.32 27.32 0 011.72 3.31 45.69 45.69 0 012 5.83c0 .09.05.17.07.26.17.6.31 1.21.47 1.85s.23 1 .37 1.58c-1.73.45-3.38.93-5 1.3a29.67 29.67 0 01-7.08.72 19.15 19.15 0 01-2-.11h-.04a12 12 0 01-10.34-9.56zm29.8 5.06a12 12 0 01.54 14.09c-3.8 5.56-9.75 5.62-13.65 2.73a10.86 10.86 0 01-4.52-10.08h.76A41.92 41.92 0 0027.95 30c.73-.25.94-.65.76-1.45s-.37-1.62-.56-2.43c1-.4 2.05-.84 3-1.33.31.3.52.6.77.91zm-.25-3.36c-.63.37-1.27.7-1.92 1s-1.41.64-2.13.91c0-.12-.06-.23-.09-.35-.32-1.11-.67-2.2-1.07-3.28a33 33 0 00-1.35-3.32 30 30 0 00-2.36-4.25 13.88 13.88 0 00-4.24-4.1 12 12 0 018.65-6.83C33.78.88 38.03 5.04 38.74 9.85c.66 4.48-1 8.21-4.81 11a21.83 21.83 0 01-2.26 1.49z"
      fillRule="evenodd"
    />
  </svg>
);

SVG.propTypes = {
  style: PropTypes.object.isRequired,
};

export default SVG;
